import { PROMPT_RECIPES, type PromptRecipe } from "@/agents-v2/components/agents/prompt-recipes";

/**
 * The "/" recipes offered in Word: one per thing the pane can do for the
 * writer, and no more. Shared review recipes come from the web app's
 * catalogue by id so their prompts stay in step; the Word-only ones act in
 * the document itself, through the template and sync tools.
 */
const scoreResponse = PROMPT_RECIPES.find((recipe) => recipe.id === "score-response");

const WORD_ONLY: PromptRecipe[] = [
  {
    id: "draft-this-section",
    category: "write",
    title: "Draft this section",
    description: "Write a first draft under the current heading from the tender and our library",
    prompt:
      "Draft the section under the current heading of my document. Read the heading and any notes already there, use the tender documents for what the question asks and how it is scored, search our content library for evidence and case studies, and write the draft into the document as tracked changes in the bid's tone of voice. Keep the heading; replace placeholder text; do not paste the draft into your reply.",
  },
  {
    id: "tighten-selection",
    category: "write",
    title: "Tighten the selected text",
    description: "Cut repetition and filler without losing substance",
    prompt:
      "Tighten the selected text: remove repetition, filler and hedging, keep every claim and figure, and keep the tone. Make the change in the document as a tracked change and tell me how many words it saved.",
  },
  {
    id: "hit-word-count-in-doc",
    category: "write",
    title: "Hit a word count",
    description: "Bring the current section to a target length",
    prompt:
      "Bring the section under the current heading to the target word count I give you (ask me for it if I have not said). Cut or add content, not padding, keeping the points the evaluation criteria reward. Make the changes in the document as tracked changes and report the before and after counts.",
  },
  {
    id: "add-evidence-in-doc",
    category: "write",
    title: "Add evidence",
    description: "Back the claims in the selected text with library evidence",
    prompt:
      "Find claims in the selected text (or the current section) that have no evidence, search our content library for case studies, figures or accreditations that support them, and add one or two sentences of specific evidence after each claim as tracked changes. Cite the source in your reply, not in the document.",
  },
  {
    id: "apply-our-template",
    category: "write",
    title: "Apply our template",
    description: "Put our house template's styles, cover and headers on this document",
    prompt:
      "Apply our organisation's document template to this document: its styles, cover and closing pages, headers and footers, and page setup. Tell me what landed and what this Word could not do.",
  },
  {
    id: "get-from-mytender",
    category: "write",
    title: "Get my answers from mytender",
    description: "Bring the answers written in mytender into this document",
    prompt:
      "Get every question's answer from mytender into this document. Tell me which answers arrived and which changed, and remind me that the changes are waiting for review.",
  },
  {
    id: "send-to-mytender",
    category: "write",
    title: "Send my changes to mytender",
    description: "Save the answers in this document to mytender as new versions",
    prompt:
      "Send the answers in this document to mytender so they are saved there as the current versions. Show me what will be sent before you send it.",
  },
];

export const WORD_RECIPES: PromptRecipe[] = [...WORD_ONLY, ...(scoreResponse ? [scoreResponse] : [])];
